module.exports = __webpack_public_path__ + "static/13-db88a81435c64a875573c07b07fbd3ce.png";